import { useAuth } from '@clerk/clerk-react';
import { useState, useCallback } from 'react';

const DOCUMENSO_URL = import.meta.env.VITE_REDIRECT_URL;

export const useDocumensoRedirect = () => {
  const { getToken } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const redirectToDocumenso = useCallback(
    async (destinationPath?: string) => {
      setIsLoading(true);
      setError(null);

      try {
        const token = await getToken();
        if (!token) {
          throw new Error('Session expired. Please sign in again.');
        }

        const redirectUrl = new URL('/auth/clerk', DOCUMENSO_URL);
        redirectUrl.searchParams.set('clerk_token', token);
        redirectUrl.searchParams.set('redirect_url', destinationPath || '/documents');

        window.open(redirectUrl.toString(), '_blank');
      } catch (err) {
        setIsLoading(false);
        setError(err instanceof Error ? err.message : 'An unexpected error occurred');
      }
    },
    [getToken]
  );

  return { redirectToDocumenso, isLoading, error };
};
